import { render } from "./LoggedInNavDash.vue?vue&type=template&id=ba9c46e4&scoped=true"
import script from "./LoggedInNavDash.vue?vue&type=script&lang=js"
export * from "./LoggedInNavDash.vue?vue&type=script&lang=js"

import "./LoggedInNavDash.vue?vue&type=style&index=0&id=ba9c46e4&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9c46e4"]])

export default __exports__